export const iconFontAwesomeAlphabetY = (
	<i className="fa-solid fa-y"></i>
);
